import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Image } from '../common/components';
import { useMobile } from '../common/hooks/use-mobile';
import { transformUnit } from '../common/utils';
import './index.module.scss';
import { useDesignContext } from '../design-provider';
var actionBtnMap = {
  "double": '领取',
  triple: '领取'
};
var couponTagMap = {
  '%': '折扣券',
  $: '满减券'
};
export var CouponItem = function CouponItem(props) {
  var _classNames;
  var mobile = props.mobile,
    mode = props.mode,
    cardStyle = props.cardStyle,
    coupon = props.coupon,
    onReceive = props.onReceive;
  return _jsxs("div", Object.assign({
    className: classNames('cms-coupon-item-wrap', (_classNames = {
      'cms-coupon-item-wrap-mobile': mobile
    }, _defineProperty(_classNames, "style".concat(cardStyle), true), _defineProperty(_classNames, mode, true), _classNames))
  }, {
    children: [_jsxs("div", Object.assign({
      className: 'content-wrap'
    }, {
      children: [_jsxs("div", Object.assign({
        className: 'discount-des-wrap'
      }, {
        children: [_jsxs("div", Object.assign({
          className: 'discount-wrap'
        }, {
          children: [coupon.ecouponType !== '%' && _jsx("span", Object.assign({
            className: 'text'
          }, {
            children: coupon.ecouponType || ''
          })), _jsx("span", Object.assign({
            className: 'value'
          }, {
            children: coupon.ecouponValue || ''
          })), coupon.ecouponType === '%' && _jsx("span", Object.assign({
            className: 'text '
          }, {
            children: coupon.ecouponType
          }))]
        })), _jsx("span", Object.assign({
          className: 'des truncate'
        }, {
          children: coupon.couponCondition || ''
        }))]
      })), _jsxs("div", Object.assign({
        className: 'info-wrap'
      }, {
        children: [_jsx("div", Object.assign({
          className: 'title truncate'
        }, {
          children: coupon.couponHeader
        })), _jsx("div", Object.assign({
          className: 'des truncate'
        }, {
          children: coupon.couponDetails
        })), _jsxs("div", Object.assign({
          className: 'time'
        }, {
          children: ["\u6D3B\u52A8\u671F\u81F3", '    ', coupon.endDate]
        }))]
      })), _jsx("div", Object.assign({
        className: 'action-wrap'
      }, {
        children: _jsx("div", Object.assign({
          className: 'action-btn',
          onClick: function onClick() {
            if (onReceive) {
              onReceive({
                data: coupon
              });
            }
          }
        }, {
          children: _jsx("span", {
            children: actionBtnMap[mode] || '立即领取'
          })
        }))
      }))]
    })), _jsx("div", Object.assign({
      className: classNames('cms-coupon-tag-wrap', {
        red: coupon.ecouponType !== '%',
        mobile: mobile
      })
    }, {
      children: couponTagMap[coupon.ecouponType]
    }))]
  }));
};
var Coupon = function Coupon(props) {
  var _props$coupons = props.coupons,
    coupons = _props$coupons === void 0 ? [] : _props$coupons,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'single' : _props$mode,
    _props$imageGap = props.imageGap,
    imageGap = _props$imageGap === void 0 ? 0 : _props$imageGap,
    _props$pagePadding = props.pagePadding,
    pagePadding = _props$pagePadding === void 0 ? 0 : _props$pagePadding,
    _props$cardStyle = props.cardStyle,
    cardStyle = _props$cardStyle === void 0 ? '1' : _props$cardStyle,
    more = props.more,
    moreImage = props.moreImage,
    moreTarget = props.moreTarget;
  var mobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink;
  if (mode === 'scroll') {
    return _jsx("div", Object.assign({
      className: classNames('box-border overflow-hidden mx-auto w-full max-w-pc scroll', {
        'scroll-mobile': mobile
      }),
      style: {
        paddingLeft: transformUnit(pagePadding, mobile),
        paddingRight: transformUnit(pagePadding, mobile)
      }
    }, {
      children: _jsxs(Swiper, Object.assign({
        observer: true,
        observeParents: true,
        resizeObserver: true,
        spaceBetween: transformUnit(imageGap, mobile, false),
        freeMode: true,
        slidesPerView: 'auto'
      }, {
        children: [coupons.map(function (coupon) {
          return _jsx(SwiperSlide, {
            children: _jsx(CouponItem, {
              coupon: coupon,
              cardStyle: cardStyle,
              mode: mode,
              mobile: mobile
            })
          }, coupon.id);
        }), more === 'open' && moreImage && _jsx(SwiperSlide, Object.assign({
          className: 'block h-auto more'
        }, {
          children: _jsx("a", Object.assign({
            className: 'block',
            href: designOnLink(moreTarget)
          }, {
            children: _jsx(Image, {
              className: 'w-full h-full object-contain',
              src: moreImage
            })
          }))
        }), 'more')]
      }))
    }));
  }
  return _jsx("div", Object.assign({
    className: classNames('box-border grid mx-auto w-full max-w-pc', {
      'grid-cols-1': mode === 'single',
      'grid-cols-2': mode === 'double' || mode === 'triple' && mobile,
      'grid-cols-3': mode === 'triple' && !mobile
    }),
    style: {
      gap: transformUnit(imageGap, mobile),
      paddingLeft: transformUnit(pagePadding, mobile),
      paddingRight: transformUnit(pagePadding, mobile)
    }
  }, {
    children: coupons.map(function (coupon) {
      return _jsx("div", Object.assign({
        className: 'flex justify-center'
      }, {
        children: _jsx(CouponItem, {
          className: 'w-full',
          coupon: coupon,
          cardStyle: cardStyle,
          mode: mode,
          mobile: mobile
        })
      }), coupon.id);
    })
  }));
};
export default Coupon;